import { useEffect, useCallback } from 'react'
import subscriptionService from '../services/subscriptionService'
import userService from '../services/userService'

/**
 * Hook to monitor subscription expiry and automatically handle downgrades
 * Runs periodic checks to ensure subscription enforcement
 */
const useSubscriptionMonitor = () => {
  // Check subscription status
  const checkSubscriptionStatus = useCallback(() => {
    const user = userService.getCurrentUser()
    if (!user || user.subscription_tier === 'free') return true
    
    // This will automatically handle expiry if detected
    return subscriptionService.isSubscriptionActive()
  }, [])

  // Setup periodic subscription monitoring
  useEffect(() => {
    // Initial check on mount
    checkSubscriptionStatus()

    // Check every 5 minutes for subscription expiry
    const intervalId = setInterval(() => {
      checkSubscriptionStatus()
    }, 5 * 60 * 1000) // 5 minutes

    // Check when user becomes active (tab focus)
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        checkSubscriptionStatus()
      }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)

    // Cleanup
    return () => {
      clearInterval(intervalId)
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [checkSubscriptionStatus])

  return {
    checkSubscriptionStatus
  }
}

export default useSubscriptionMonitor